import { render } from "./PlayPage.vue?vue&type=template&id=744fa62b&scoped=true"
import script from "./PlayPage.vue?vue&type=script&lang=js"
export * from "./PlayPage.vue?vue&type=script&lang=js"

import "./PlayPage.vue?vue&type=style&index=0&id=744fa62b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-744fa62b"

export default script